// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Logic$ReactHooksTemplate = require("./Logic.res.js");
var Action$ReactHooksTemplate = require("./Action.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var DateCondition$ReactHooksTemplate = require("./DateCondition.res.js");
var ListCondition$ReactHooksTemplate = require("./ListCondition.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");
var NumberCondition$ReactHooksTemplate = require("./NumberCondition.res.js");
var StringCondition$ReactHooksTemplate = require("./StringCondition.res.js");

function nodes(t) {
  return t.nodes;
}

function edges(t) {
  return t.edges;
}

function path(t) {
  return t.path;
}

function sortLogicsByPriority(logics) {
  return List.sort((function (logic1, logic2) {
                if (Logic$ReactHooksTemplate.priority(logic1) < Logic$ReactHooksTemplate.priority(logic2)) {
                  return -1;
                } else if (Logic$ReactHooksTemplate.priority(logic1) > Logic$ReactHooksTemplate.priority(logic2)) {
                  return 1;
                } else {
                  return 0;
                }
              }), logics);
}

function setLhsForDataFieldLogics(logics) {
  Belt_List.forEach(logics, (function (logic) {
          Belt_List.forEach(Logic$ReactHooksTemplate.conditions(logic), (function (cond) {
                  var d = LogicCondition$ReactHooksTemplate.lhs(cond);
                  if (d.TAG === "Question") {
                    return LogicCondition$ReactHooksTemplate.conditionType(cond);
                  } else {
                    return LogicCondition$ReactHooksTemplate.setLhs(cond, {
                                TAG: "DataField",
                                _0: d._0
                              });
                  }
                }));
        }));
}

function questions(t) {
  return Belt_List.keepMap(Belt_List.keep(t.path, (function (x) {
                    switch (x.TAG) {
                      case "Welcome" :
                      case "ThankYou" :
                          return false;
                      case "Question" :
                          return true;
                      
                    }
                  })), (function (x) {
                switch (x.TAG) {
                  case "Welcome" :
                  case "ThankYou" :
                      return ;
                  case "Question" :
                      return x._0;
                  
                }
              }));
}

function isSkippedNode(skippedNodes, node) {
  return List.exists((function (x) {
                switch (x.TAG) {
                  case "Welcome" :
                      return false;
                  case "ThankYou" :
                      switch (node.TAG) {
                        case "ThankYou" :
                            return Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(x._0), ThankYou$ReactHooksTemplate.uuid(node._0));
                        case "Welcome" :
                        case "Question" :
                            return false;
                        
                      }
                  case "Question" :
                      switch (node.TAG) {
                        case "Welcome" :
                        case "ThankYou" :
                            return false;
                        case "Question" :
                            return Question$ReactHooksTemplate.equals(x._0, node._0);
                        
                      }
                  
                }
              }), skippedNodes);
}

function findTrueConditionLogic(question, edges) {
  var logics = sortLogicsByPriority(Logic$ReactHooksTemplate.findLogicByTrigger(edges, question));
  return Belt_List.getBy(logics, (function (logic) {
                return !Belt_List.some(Logic$ReactHooksTemplate.conditions(logic), (function (cond) {
                              var q = LogicCondition$ReactHooksTemplate.lhs(cond);
                              if (q.TAG === "Question") {
                                var surveyQuestion = Question$ReactHooksTemplate.equals(q._0, question);
                                if (!surveyQuestion) {
                                  return false;
                                }
                                var n = LogicCondition$ReactHooksTemplate.conditionType(cond);
                                var tmp;
                                switch (n.TAG) {
                                  case "NumberCondition" :
                                      tmp = NumberCondition$ReactHooksTemplate.evaluate(NumberCondition$ReactHooksTemplate.setLhs(n._0, {
                                                TAG: "Question",
                                                _0: question
                                              }));
                                      break;
                                  case "StringCondition" :
                                      tmp = StringCondition$ReactHooksTemplate.evaluate(StringCondition$ReactHooksTemplate.setLhs(n._0, {
                                                TAG: "Question",
                                                _0: question
                                              }));
                                      break;
                                  case "ListCondition" :
                                      tmp = ListCondition$ReactHooksTemplate.evaluate(ListCondition$ReactHooksTemplate.setLhs(n._0, {
                                                TAG: "Question",
                                                _0: question
                                              }));
                                      break;
                                  case "DateCondition" :
                                      tmp = DateCondition$ReactHooksTemplate.evaluate(DateCondition$ReactHooksTemplate.setLhs(n._0, {
                                                TAG: "Question",
                                                _0: question
                                              }));
                                      break;
                                  
                                }
                                return tmp === false;
                              }
                              var n$1 = LogicCondition$ReactHooksTemplate.conditionType(cond);
                              var tmp$1;
                              switch (n$1.TAG) {
                                case "NumberCondition" :
                                    tmp$1 = NumberCondition$ReactHooksTemplate.evaluate(n$1._0);
                                    break;
                                case "StringCondition" :
                                    tmp$1 = StringCondition$ReactHooksTemplate.evaluate(n$1._0);
                                    break;
                                case "ListCondition" :
                                    tmp$1 = ListCondition$ReactHooksTemplate.evaluate(n$1._0);
                                    break;
                                case "DateCondition" :
                                    tmp$1 = DateCondition$ReactHooksTemplate.evaluate(n$1._0);
                                    break;
                                
                              }
                              return tmp$1 === false;
                            }));
              }));
}

function findNodeIndex(node, nodes) {
  var predicate = function (a, b) {
    switch (a.TAG) {
      case "Welcome" :
          switch (b.TAG) {
            case "Welcome" :
                return true;
            case "ThankYou" :
            case "Question" :
                return false;
            
          }
      case "ThankYou" :
          switch (b.TAG) {
            case "ThankYou" :
                return Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(a._0), ThankYou$ReactHooksTemplate.uuid(b._0));
            case "Welcome" :
            case "Question" :
                return false;
            
          }
      case "Question" :
          switch (b.TAG) {
            case "Welcome" :
            case "ThankYou" :
                return false;
            case "Question" :
                return Question$ReactHooksTemplate.equals(a._0, b._0);
            
          }
      
    }
  };
  var _i = 0;
  var _l = nodes;
  while(true) {
    var l = _l;
    var i = _i;
    if (!l) {
      return ;
    }
    if (predicate(l.hd, node)) {
      return i;
    }
    _l = l.tl;
    _i = i + 1 | 0;
    continue ;
  };
}

function nodesToSkip(logic, node, t) {
  return Belt_List.flatten(List.map((function (x) {
                    var skipTarget = Action$ReactHooksTemplate.actionType(x);
                    switch (skipTarget.TAG) {
                      case "Skip" :
                          var skipTarget$1 = skipTarget._0;
                          if (skipTarget$1.TAG === "Questions") {
                            return List.map((function (q) {
                                          return {
                                                  TAG: "Question",
                                                  _0: q
                                                };
                                        }), skipTarget$1._0);
                          } else {
                            return List.map((function (t) {
                                          return {
                                                  TAG: "ThankYou",
                                                  _0: t
                                                };
                                        }), skipTarget$1._0);
                          }
                      case "Jump" :
                          var jumpTarget = skipTarget._0;
                          var tmp;
                          tmp = jumpTarget.TAG === "Question" ? findNodeIndex({
                                  TAG: "Question",
                                  _0: jumpTarget._0
                                }, t.nodes) : findNodeIndex({
                                  TAG: "ThankYou",
                                  _0: jumpTarget._0
                                }, t.nodes);
                          var targetIndex = Belt_Option.getWithDefault(tmp, 0);
                          var fromIndex = Belt_Option.getWithDefault(findNodeIndex(node, t.nodes), 0);
                          return Belt_List.keepWithIndex(t.nodes, (function (param, i) {
                                        if (i > fromIndex) {
                                          return i < targetIndex;
                                        } else {
                                          return false;
                                        }
                                      }));
                      case "Redirection" :
                      case "TicketGeneration" :
                          return /* [] */0;
                      
                    }
                  }), Logic$ReactHooksTemplate.actions(logic)));
}

function buildPath(t) {
  var match = List.fold_left((function (param, node) {
          var skippedNodes = param[1];
          var path = param[0];
          switch (node.TAG) {
            case "Welcome" :
                return [
                        List.append(path, {
                              hd: node,
                              tl: /* [] */0
                            }),
                        skippedNodes
                      ];
            case "ThankYou" :
                if (isSkippedNode(skippedNodes, node)) {
                  return [
                          path,
                          skippedNodes
                        ];
                }
                var match = Belt_List.head(List.rev(path));
                var isThankyouInPath;
                if (match !== undefined) {
                  switch (match.TAG) {
                    case "ThankYou" :
                        isThankyouInPath = true;
                        break;
                    case "Welcome" :
                    case "Question" :
                        isThankyouInPath = false;
                        break;
                    
                  }
                } else {
                  isThankyouInPath = false;
                }
                if (isThankyouInPath) {
                  return [
                          path,
                          skippedNodes
                        ];
                } else {
                  return [
                          List.append(path, {
                                hd: node,
                                tl: /* [] */0
                              }),
                          skippedNodes
                        ];
                }
            case "Question" :
                if (isSkippedNode(skippedNodes, node)) {
                  return [
                          path,
                          skippedNodes
                        ];
                }
                var path$p = List.append(path, {
                      hd: node,
                      tl: /* [] */0
                    });
                var logic = findTrueConditionLogic(node._0, t.edges);
                if (logic !== undefined) {
                  return [
                          path$p,
                          List.append(skippedNodes, nodesToSkip(Caml_option.valFromOption(logic), node, t))
                        ];
                } else {
                  return [
                          path$p,
                          skippedNodes
                        ];
                }
            
          }
        }), [
        /* [] */0,
        /* [] */0
      ], t.nodes);
  return {
          nodes: t.nodes,
          edges: t.edges,
          path: match[0]
        };
}

function updateNode(node, t) {
  switch (node.TAG) {
    case "Welcome" :
    case "ThankYou" :
        return t;
    case "Question" :
        var question = node._0;
        var nodes$p = List.map((function (n) {
                switch (n.TAG) {
                  case "Welcome" :
                  case "ThankYou" :
                      return n;
                  case "Question" :
                      if (Question$ReactHooksTemplate.equals(n._0, question)) {
                        return node;
                      } else {
                        return n;
                      }
                  
                }
              }), t.nodes);
        return buildPath({
                    nodes: nodes$p,
                    edges: t.edges,
                    path: t.path
                  });
    
  }
}

function create(survey) {
  var questionNodes = List.map((function (x) {
          return {
                  TAG: "Question",
                  _0: x
                };
        }), Survey$ReactHooksTemplate.questions(survey));
  var thankyouNodes = List.map((function (y) {
          return {
                  TAG: "ThankYou",
                  _0: y
                };
        }), Survey$ReactHooksTemplate.thankYouList(survey));
  var welcome = Survey$ReactHooksTemplate.welcome(survey);
  var nodes = welcome !== undefined ? Belt_List.concat(Belt_List.concat({
              hd: {
                TAG: "Welcome",
                _0: Caml_option.valFromOption(welcome)
              },
              tl: /* [] */0
            }, questionNodes), thankyouNodes) : Belt_List.concat(questionNodes, thankyouNodes);
  setLhsForDataFieldLogics(Survey$ReactHooksTemplate.logics(survey));
  var edges = Survey$ReactHooksTemplate.logics(survey);
  var match = Belt_List.head(thankyouNodes);
  var path = match !== undefined ? (
      welcome !== undefined ? Belt_List.concat(Belt_List.concat({
                  hd: {
                    TAG: "Welcome",
                    _0: Caml_option.valFromOption(welcome)
                  },
                  tl: /* [] */0
                }, questionNodes), {
              hd: match,
              tl: /* [] */0
            }) : List.append(questionNodes, {
              hd: match,
              tl: /* [] */0
            })
    ) : (
      welcome !== undefined ? Belt_List.concat({
              hd: {
                TAG: "Welcome",
                _0: Caml_option.valFromOption(welcome)
              },
              tl: /* [] */0
            }, questionNodes) : questionNodes
    );
  return buildPath({
              nodes: nodes,
              edges: edges,
              path: path
            });
}

function nextNode(currentNode, t) {
  var index = findNodeIndex(currentNode, t.path);
  if (index !== undefined) {
    return Belt_List.get(t.path, index + 1 | 0);
  }
  
}

function startNode(t) {
  return Belt_List.head(t.path);
}

function thankYou(t) {
  var match = Belt_List.head(Belt_List.reverse(t.path));
  if (match === undefined) {
    return ;
  }
  switch (match.TAG) {
    case "ThankYou" :
        return Caml_option.some(match._0);
    case "Welcome" :
    case "Question" :
        return ;
    
  }
}

function previousNode(currentNode, t) {
  var index = findNodeIndex(currentNode, t.path);
  if (index !== undefined && index !== 0) {
    return Belt_List.get(t.path, index - 1 | 0);
  }
  
}

exports.nodes = nodes;
exports.edges = edges;
exports.path = path;
exports.create = create;
exports.updateNode = updateNode;
exports.nextNode = nextNode;
exports.previousNode = previousNode;
exports.startNode = startNode;
exports.questions = questions;
exports.thankYou = thankYou;
/* Logic-ReactHooksTemplate Not a pure module */
